Object.defineProperty(exports,"__esModule",{value:true});exports.default=









deserialize;var _clearFromIds=require('./clearFromIds');var _clearFromIds2=_interopRequireDefault(_clearFromIds);var _topics=require('./topics');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function deserialize(topic,binaryPayload){
try{
return(0,_topics.deserializer)(topic)(binaryPayload);
}catch(e){
return null;
}
}